export default "__VITE_ASSET__64cf007e__"